import React from 'react';
import {useTable} from 'react-table';

const DetailWallet = ({data}) => {

    const columns = React.useMemo(
        () => [
            {
                Header: 'Date',
                accessor: 'dtDateCreated', // accessor is the "key" in the data
            },
            {
                Header: 'Concept',
                accessor: 'sDescription',
            },
            {
                Header: 'Sale / Booking',
                accessor: 'mnSale_Amount',
            },
            {
                Header: 'ECO\'s',
                accessor: 'mnEco',
            },
            {
                Header: 'Air ECO\'s',
                accessor: 'mnAirEco',
            },
            {
                Header: 'Cashable USD',
                accessor: 'mnCashable_USD',
            },
        ],
        []
    )

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({columns, data})


    return (
        <>
            <div className="container-fluid p-5">
                <div className="col_full center">
                    <h3>ECO Account</h3>
                </div>

                <div className="col_full">
                    <table className="table table-borderless table-hover"  {...getTableProps()} >
                        <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th
                                        {...column.getHeaderProps()}
                                        style={{
                                            borderBottom: 'solid 5px #263f7a',

                                            color: 'black'
                                        }}
                                    >
                                        {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                        {rows.map(row => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map(cell => {
                                        return (
                                            <td
                                                {...cell.getCellProps()}
                                                style={{
                                                    padding: '15px',
                                                    borderBottom: 'solid 1px #ebebeb'
                                                }}
                                            >
                                                {cell.render('Cell')}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default DetailWallet;
